import axios from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
import store from '../store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Cache-Control': 'no-cache' },
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
})

const API = {
  PARTICIPANT: '/participant',
  GETUSER: '/participant/:token',
  SENDQUALISCORE: '/participant/:token/send',
  PAGE: '/page/:slug',
  SCREENING: '/participant/:token/survey/screening',
  QUALISCORE: '/participant/:token/survey/qualiscore',
  ANSWER: '/question/:id/answer',
  SPLASH: '/splashscreen/:slug',
  RESULTS: '/participant/:token/results',
  ADVICE: '/advice/:slug',
  FILTERS: '/filters/:slug',
  SURVEYFILTERSPARTICIPANT: '/participant/:token/survey/:slug?only_participant_answers=1',
  SURVEYFILTERS: '/survey/:slug?filters=:filters_slug',
  SURVEYFILTERSQUALISCORE: '/survey/:slug/score?filters=:filters_slug',
  QUESTIONFILTERS: '/question/:slug?filters=:filters_slug'
}

function url (path, ...segments) {
  let i = 0
  const { state } = store
  const uri = path.replace(/:\w+/g, () => {
    let s = segments[i]
    i += 1
    return s
  })

  return uri
}

export default {
  install (Vue, options) {
    const $api = {
      registerUser() {
        return http.post(url(API.PARTICIPANT))
      },
      sendQualiscore(token, options) {
        return http.post(url(API.SENDQUALISCORE, token), options)
      },
      getUser(token) {
        return http.get(url(API.GETUSER, token), { cache: false })
      },
      getPage(slug) {
        return http.get(url(API.PAGE, slug))
      },
      getAdvice(slug) {
        return http.get(url(API.ADVICE, slug))
      },
      getResults(token) {
        return http.get(url(API.RESULTS, token))
      },
      getScreening(token) {
        return http.get(url(API.SCREENING, token), { cache: false })
      },
      getQualiscore(token) {
        return http.get(url(API.QUALISCORE, token), { cache: false })
      },
      postAnswer(id, answer) {
        return http.post(url(API.ANSWER, id), answer)
      },
      getSplashscreen(slug) {
        return http.get(url(API.SPLASH, slug))
      },
      getSurveyFilters(slug, filters = 'all,all') {
        return http.get(url(API.SURVEYFILTERS, slug, filters))
      },
      getSurveyFiltersQualiscore(slug, filters = 'all,all') {
        return http.get(url(API.SURVEYFILTERSQUALISCORE, slug, filters))
      },
      getSurveyFiltersParticipant(token, slug) {
        return http.get(url(API.SURVEYFILTERSPARTICIPANT, token, slug))
      },
      getQuestionFilters(slug, filters = 'all,all') {
        return http.get(url(API.QUESTIONFILTERS, slug, filters))
      },
      getFilters(slug) {
        return http.get(url(API.FILTERS, slug))
      }
    }

    Vue.prototype.$api = $api
    Vue.$api = $api
  }
}
